export const createSnotifyAdapter = (toast) => {
  const notify = (type, message, title) => {
    const text = title ? `${title}: ${message}` : message;
    if (toast && typeof toast[type] === 'function') {
      toast[type](text);
      return;
    }
    if (toast && typeof toast === 'function') {
      toast(text);
    }
  };

  return {
    success: (message, title) => notify('success', message, title),
    error: (message, title) => notify('error', message, title),
    warning: (message, title) => notify('warning', message, title),
    info: (message, title) => notify('info', message, title),
    clear: () => {
      if (toast && typeof toast.clear === 'function') toast.clear();
    },
  };
};

// Shared instance for non-component modules (e.g. api-client).
let sharedSnotify = null;
export const setSnotify = (instance) => { sharedSnotify = instance; };
export const getSnotify = () => sharedSnotify;
